// Module
var code = `<div class="modal hide fade">
  <div class="modal-header">
    <button type="button" class="close" aria-hidden="true" ng-click="\$ctrl.onCancel()" >&times;</button>
    <div ng-transclude="header"></div>
  </div>

  <div class="modal-body">
    <div ng-transclude="body"></div>
  </div>

  <div class="modal-footer" ng-if="!\$ctrl.hideFooter">
    <div ng-transclude="footer">
      <button type="button" class="btn" ng-click="\$ctrl.onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary" ng-click="\$ctrl.onOk()" ng-disabled="\$ctrl.form.\$invalid">Ok</button>
    </div>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/modal/modal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;